import React from 'react';
import { SvgIconProps } from '@mui/material';

export const NotificationsIcon: React.FC<SvgIconProps> = (props) => (
    <svg
        width="29"
        height="29"
        viewBox="0 0 29 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clipPath="url(#clip0_2042_291)">
            <path
                d="M13.5257 28.4817C11.101 28.4817 9.12659 26.5085 9.12659 24.0826C9.12659 23.5969 9.52074 23.2028 10.0064 23.2028C10.4921 23.2028 10.8862 23.5969 10.8862 24.0826C10.8862 25.5385 12.0711 26.722 13.5257 26.722C14.9803 26.722 16.1651 25.5385 16.1651 24.0826C16.1651 23.5969 16.5593 23.2028 17.0449 23.2028C17.5306 23.2028 17.9248 23.5969 17.9248 24.0826C17.9248 26.5085 15.9505 28.4817 13.5257 28.4817Z"
                fill="currentColor"
            />
            <path
                d="M23.2037 24.9624H3.84776C2.71577 24.9624 1.79492 24.0416 1.79492 22.9096C1.79492 22.3088 2.05655 21.74 2.51278 21.3493C2.54221 21.3235 2.57378 21.3001 2.60665 21.2788C4.32869 19.7761 5.31419 17.6141 5.31419 15.3312V12.0584C5.31419 7.53039 8.99885 3.8468 13.5257 3.8468C13.7135 3.8468 13.9165 3.85024 14.1042 3.88203C14.5838 3.96172 14.9078 4.4158 14.8279 4.89438C14.7482 5.37295 14.2859 5.69687 13.8155 5.61696C13.7216 5.60171 13.6185 5.60644 13.5257 5.60644C9.9691 5.60644 7.07382 8.50042 7.07382 12.0584V15.3312C7.07382 18.1655 5.83143 20.8473 3.6684 22.6877C3.65079 22.7019 3.63554 22.7148 3.61663 22.7276C3.58506 22.7676 3.55456 22.8286 3.55456 22.9096C3.55456 23.069 3.68838 23.2028 3.84776 23.2028H23.2037C23.3633 23.2028 23.4971 23.069 23.4971 22.9096C23.4971 22.8273 23.4666 22.7676 23.4338 22.7276C23.4162 22.7148 23.4009 22.7019 23.3833 22.6877C21.219 20.846 19.9779 18.1655 19.9779 15.3312V14.0528C19.9779 13.5671 20.372 13.1729 20.8577 13.1729C21.3434 13.1729 21.7375 13.5671 21.7375 14.0528V15.3312C21.7375 17.6154 22.7241 19.7784 24.4485 21.2825C24.4801 21.3035 24.5106 21.3259 24.5387 21.3506C24.9952 21.74 25.2568 22.3088 25.2568 22.9096C25.2568 24.0416 24.3359 24.9624 23.2037 24.9624V24.9624Z"
                fill="currentColor"
            />
            <path
                d="M21.7375 12.0583C18.5032 12.0583 15.8719 9.42726 15.8719 6.19303C15.8719 2.9588 18.5032 0.327515 21.7375 0.327515C24.9717 0.327515 27.6028 2.9588 27.6028 6.19303C27.6028 9.42726 24.9717 12.0583 21.7375 12.0583ZM21.7375 2.08715C19.4733 2.08715 17.6316 3.92884 17.6316 6.19303C17.6316 8.45702 19.4733 10.2987 21.7375 10.2987C24.0014 10.2987 25.8431 8.45702 25.8431 6.19303C25.8431 3.92884 24.0014 2.08715 21.7375 2.08715Z"
                fill="currentColor"
            />
        </g>
        <defs>
            <clipPath id="clip0_2042_291">
                <rect
                    width="28.1541"
                    height="28.1541"
                    fill="white"
                    transform="translate(0.640137 0.327515)"
                />
            </clipPath>
        </defs>
    </svg>
);

export default NotificationsIcon;
